import { createReducer, on } from '@ngrx/store';
import * as categoriesActions from './category-tree-actions';
import * as fromCategories from './category-tree-state';

const initialState:  fromCategories.State = {isLoading: false, data: null, parentCategory: ''};
export const reducer = createReducer(
  initialState,
  on(categoriesActions.CancelRequestCategoryTree, (state) => {
    return {...state, isLoading: false};
  }),
  on(categoriesActions.CategoryTreeFailure, (state) => {
    return {...state, isLoading: false};
  }),
  on(categoriesActions.GetCategoryTree, (state) => {
    return {...state, isLoading: true};
  }),
  on(categoriesActions.CategoryTreeLoaded, (state, {data}) => {
    return {...state, isLoading: false, data}
  }),
  on(categoriesActions.UpdateParentCategory, (state, {parentCategory}) => {
    return {...state, parentCategory}
  })
);